import * as React from 'react';
import checkboxActive from './../../../images/checkbox/active.png'
import checkboxDisabled from './../../../images/checkbox/disabled.png'
import './checkbox.css'
interface ICheckboxProps {
    label: string;
    checked: boolean;
    disabled: boolean;
    onChange?: (e) => any;
    calendarCheckbox?: boolean;
    className?: string;
}


export const Checkbox: React.SFC<ICheckboxProps> = (props) => {
    return (
        <div className={`checkbox ${props.className ? props.className : ''}`} onClick={() => {
            if (props.onChange && !props.disabled) {
                props.onChange(!props.checked)
            }
        }}>
            {props.calendarCheckbox ? <i className={`fa fa-calendar-${props.checked ? 'check-' : ''}o checkbox-icon`} /> : <img src={props.checked ? checkboxActive : checkboxDisabled} />}
            <p>{props.label}</p>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/share/components/Checkbox/Checkbox.tsx